import * as Sentry from "@sentry/react";
import { Link } from "@tanstack/react-router";
import { useEffect } from "react";

import { Button } from "@/components/ui/button";

type ErrorProps = {
  error: Error;
  onRetry?: () => void;
  title: string;
  logMessage: string;
};

export function ErrorView({ error, onRetry, title, logMessage }: ErrorProps) {
  const { logger } = Sentry;

  useEffect(() => {
    Sentry.captureException(error);
    logger.error(logMessage, { message: error.message });
  }, [error, logger, logMessage]);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4">
      <div className="text-center">
        <h2 className="mb-2 text-lg font-semibold text-foreground">{title}</h2>
        <p className="mb-6 text-sm text-muted-foreground">{error.message}</p>
        <div className="flex justify-center gap-3">
          {!!onRetry && <Button onClick={onRetry}>Try again</Button>}
          <Button asChild variant="outline">
            <Link to="/">Go home</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
